import type { ViewState } from '#components/Root/viewModel'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import {
  CUSTOM_LINKS_ONLY,
  NODE_SELECT,
  NODE_CUSTOM,
} from '../../utils/constants'
import i18nx from '../../utils/i18n'
import BottomActions from '../BottomActions'
import CustomLinksOnly from '../CustomLinksOnly'
import GenericOptionStep from '../GenericOptionStep'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const GenericComplexStep = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      {!state.currentNode.disableSearch && (
        // @ts-expect-error@2322
        <IForm onChange={viewModel.handleSearchFormChange}>
          <TextField
            className={styles.searchField}
            // @ts-expect-error@2322
            clearable
            label={i18nx.t('global.search')}
            optional
            property='term'
          />
        </IForm>
      )}
      {state.currentNode.nodes.map((childNode, index) => (
        <div className={styles.childNode} key={index}>
          {childNode.contentModelType === NODE_SELECT && (
            <GenericOptionStep
              filterTerm={viewModel.searchTerm}
              node={childNode}
              state={state}
            />
          )}
          {childNode.contentModelType === NODE_CUSTOM &&
            childNode.customType === CUSTOM_LINKS_ONLY && (
              <CustomLinksOnly
                // @ts-expect-error@2322
                filterTerm={viewModel.searchTerm}
                node={childNode}
                state={state}
              />
            )}
        </div>
      ))}
    </StepContent>
    {viewModel.showButtons && (
      <BottomActions
        // @ts-expect-error@2322
        nextEnabled={viewModel.isValid}
        onNext={viewModel.showContinue && viewModel.handleNext}
        showBack={viewModel.showBack}
      />
    )}
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, GenericComplexStep)
component.displayName = 'GenericComplexStep'
export default component
